( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('PDFExportService', PDFExportService);

    PDFExportService.$inject = ['$rootScope', '$http'];

    function PDFExportService($rootScope, $http) {
        return {
            downloadContractPDF: downloadContractPDF,
            downloadShipmentPDF: downloadShipmentPDF,
            downloadShipmentExportBillPDF: downloadShipmentExportBillPDF,
            downloadShipmentBoePDF: downloadShipmentBoePDF,
            downloadLotPDF: downloadLotPDF,
            downloadInvoicePDF: downloadInvoicePDF,
            downloadFixationPDF: downloadFixationPDF,
            downloadDebitNotePDF: downloadDebitNotePDF,
            downloadNContractPDF: downloadNContractPDF
        };

        function downloadContractPDF(id) {
            var url = "api/contracts/pdf/" + id;
            return $http.get(url, {responseType: 'arraybuffer'});
        }

        function downloadShipmentPDF(id) {
            var url = "api/shipments/pdf/" + id;
            return $http.get(url, {responseType: 'arraybuffer'});
        }

        function downloadShipmentExportBillPDF(id) {
            var url = "api/shipments/pdf/exportBill/" + id;
            return $http.get(url, {responseType: 'arraybuffer'});
        }

        function downloadShipmentBoePDF(id) {
            var url = "api/shipments/pdf/billOfExchange/" + id;
            return $http.get(url, {responseType: 'arraybuffer'});
        }

        function downloadLotPDF(id) {
            var url = "api/lots/pdf/" + id;
            return $http.get(url, {responseType: 'arraybuffer'});
        }

        function downloadInvoicePDF(invoiceId, invoiceType, showVessel, showVoyageDetails, showContract, showLot, showLCDetails, showController, showPaymentTenor, showLotWeights,
                                    showDescriptionOfGoods, showPacking, showIncoTerms, showWeightTerm, showPaymentInstructions, header) {
            var url = 'api/invoices/' + invoiceId + '/invoice-pdf?showVessel=' + showVessel + '&showVoyageDetails=' + showVoyageDetails + '&showContract=' + showContract +
                '&showLot=' + showLot + '&showLCDetails=' + showLCDetails + '&showController=' + showController + '&showPaymentTenor=' + showPaymentTenor +
                '&showLotWeights=' + showLotWeights + '&showDescriptionOfGoods=' + showDescriptionOfGoods + '&showPacking=' + showPacking + '&showIncoTerms=' + showIncoTerms +
                '&showWeightTerm=' + showWeightTerm + '&showPaymentInstructions=' + showPaymentInstructions + '&header=' + header;
            return $http.get(url, {responseType: 'arraybuffer'});
        }

        function downloadFixationPDF(contractId) {
            var url = "api/fixations/contract/pdf/" + contractId;
            return $http.get(url, {responseType: 'arraybuffer'});
        }

        function downloadDebitNotePDF(invoiceId, showCommission) {
            var url = 'api/invoices/' + invoiceId + "/debit-note-pdf?commission="+showCommission;
            return $http.get(url, {responseType: 'arraybuffer'});
        }

        function downloadNContractPDF(invoiceId, showVessel, showVoyageDetails, showContract, showLot, showLCDetails, showController, showPaymentTenor, showLotWeights,
                                      showDescriptionOfGoods, showPacking, showIncoTerms, showWeightTerm, showPaymentInstructions, header) {
            var url = 'api/invoices/' + invoiceId + "/ncontract-pdf?showVessel=" + showVessel + "&showVoyageDetails=" + showVoyageDetails + "&showContract=" + showContract +
                "&showLot=" + showLot + "&showLCDetails=" + showLCDetails + "&showController=" + showController + "&showPaymentTenor=" + showPaymentTenor +
                "&showLotWeights=" + showLotWeights + "&showDescriptionOfGoods=" + showDescriptionOfGoods + "&showPacking=" + showPacking + "&showIncoTerms=" + showIncoTerms +
                "&showWeightTerm=" + showWeightTerm + "&showPaymentInstructions=" + showPaymentInstructions + "&header=" + header;
            return $http.get(url, {responseType: 'arraybuffer'});
        }
    }

})();
